import { Component } from '@angular/core';

@Component({
  selector: 'app-paraphrasing-modes',
  templateUrl: './paraphrasing-modes.component.html',
  styleUrls: ['./paraphrasing-modes.component.scss']
})
export class ParaphrasingModesComponent {

  standardExample: boolean = true;
  academicExample: boolean = true;
  formalExample: boolean = true;
  conciseExample: boolean = true;
  simpleExample: boolean = true;

}
